module.exports = __webpack_public_path__ + "img/ico-lapide.10047b06.svg";